import { log, logE } from "../../shared/services/debug-logger";
import { oktaAuth } from "./oktaAuth";

export async function signOut() {
  const accessToken = oktaAuth.getAccessToken();

  if (!accessToken) {
    log("SERV - signOut - token unavailable");
    return;
  }

  log("SERV - signOut - clear session");

  try {
    await fetch(process.env.REACT_APP_DXO_SESSIONS_ENDPOINT ?? "", {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  } catch (err) {
    logE(new Error("SERV - signOut - clear session failed"));
  }

  log("SERV - signOut - redirect");

  await oktaAuth.signOut({
    revokeAccessToken: true,
    revokeRefreshToken: true,
    clearTokensBeforeRedirect: true,
    postLogoutRedirectUri: window.location.origin + "/auth/logout",
  });
}
